module.exports = __webpack_public_path__ + "bb4bd6045e9e0e997d535465804929e3.svg";